<template><div><h1 id="ab-journal-nach-datum" tabindex="-1"><a class="header-anchor" href="#ab-journal-nach-datum"><span>AB-Journal nach Datum</span></a></h1>
<p>AB-Journal nach Datum — Liste in Textformat aus allen aggregierten Buchungen nach Datum</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Liste in Textformat aus allen aggregierten Buchungen, die den eingegebenen Journalnummern [von Journalnummer - bis Journalnummer] entsprechen. Beträge aus den Buchungen werden pro Belegdatum kumuliert und in 4 Kategorien ausgewiesen:</p>
<p>- vereinbarte Buchungen</p>
<p>- vereinnahmte Buchungen</p>
<p>- Zahlungen</p>
<p>- Gutschriftsbewegungen</p>
<p>Der Output ist zweizeilig aufgebaut, nach Belegdatum sortiert.</p>
<p>Pfad: <code v-pre>Buchhaltung → Auswertungen → AB-Kontoauszüge → AB-Journal nach Datum</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<ul>
<li>
<p>von Journalnummer:
: inklusive, ? = unbegrenzt (wenn 'bis' = ?: von &quot;0&quot; bis Journalnummer)</p>
</li>
<li>
<p>bis:
: inklusive, ? = unbegrenzt (wenn 'von Journalnummer' = ?: von Journalnummer bis 999999)</p>
</li>
<li>
<p>von Datum:
: Belegdatum, inklusive, ? = unbegrenzt bzw. Inhalt des/der Journal/e</p>
</li>
<li>
<p>bis:
: Belegdatum, inklusive, ? = unbegrenzt bzw. Inhalt des/der Journal/e</p>
</li>
<li>
<p>vollständige Totalwerte:
: Totalwerte am Ende des Protokolls anzeigen?: ja /nein</p>
</li>
</ul>
<dl>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Portrait)</dd>
<dt>- Bildschirm</dt>
<dd>
<ul>
<li>Bildschirm</li>
</ul>
</dd>
<dt>- Drucker:</dt>
<dd>A4 hoch</dd>
<dt>- Textdatei:</dt>
<dd>Text</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Info-Felder:</td>
<td>Info-Felder:</td>
</tr>
<tr>
<td>Rekapitulation:</td>
<td>der Parameter</td>
</tr>
<tr>
<td>Spalten:</td>
<td>Spalten:</td>
</tr>
<tr>
<td>- Belegdatum:</td>
<td>Belegdatum der aggregierten Buchung</td>
</tr>
<tr>
<td>- vereinbart:</td>
<td>kumulierte Buchungen: vereinbart</td>
</tr>
<tr>
<td>- vereinnahmt:</td>
<td>kumulierte Buchungen: vereinnahmt</td>
</tr>
<tr>
<td>- bezahlt:</td>
<td>kumulierte Buchungen: bezahlt</td>
</tr>
<tr>
<td>- gutgeschrieben:</td>
<td>kumulierte Buchungen: gutgeschrieben</td>
</tr>
<tr>
<td>- lfd. Saldo:</td>
<td>Saldo pro Zeile der Spalten [vereinbart] + [vereinnahmt] + [bezahlt] + [gutgeschrieben], verrechnet mit dem lfd. Saldo der vorherigen Zeile</td>
</tr>
<tr>
<td>Zeilen:</td>
<td>Zeilen:</td>
</tr>
<tr>
<td>- TOTAL:</td>
<td>Summe aus den einzelnen Spalten - vereinbart- vereinnahmt- bezahlt- gutgeschrieben- lfd. Saldo</td>
</tr>
<tr>
<td>- COUNT:</td>
<td>Anzahl der Belege = Anzahl Belegnummern der aggregierten Buchungen</td>
</tr>
</tbody>
</table>
<h2 id="output-liste-1" tabindex="-1"><a class="header-anchor" href="#output-liste-1"><span>Output (Liste)</span></a></h2>
<p>nur wenn 'vollständige Totalwerte' = ja</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>- vereinbart:</td>
<td>Summe aus allen verarbeiteten Journalnummern</td>
</tr>
<tr>
<td>- vereinnahmt:</td>
<td>Summe aus allen verarbeiteten Journalnummern</td>
</tr>
<tr>
<td>- bezahlt:</td>
<td>Summe aus allen verarbeiteten Journalnummern</td>
</tr>
<tr>
<td>- gutgeschrieben:</td>
<td>Summe aus allen verarbeiteten Journalnummern</td>
</tr>
<tr>
<td>- Totalanzahl der Buchungen:</td>
<td>Anzahl der Buchungen (Belegnummern) insgesamt</td>
</tr>
<tr>
<td>- Debitoren Totaländerung:</td>
<td>Summe der kumulierten Spalten [vereinbart] + [vereinnahmt] + [bezahlt] + [gutgeschrieben]</td>
</tr>
</tbody>
</table>
<p>Outputbeispiel mit Totalwerten</p>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line">Datenausgabe                                29.10.1998 12:36:30 pav  Seite     0</span>
<span class="line"></span>
<span class="line">                                    drucken</span>
<span class="line">                    von Journalnummer: 0          bis: 999999</span>
<span class="line">                    von Datum        :            bis:</span>
<span class="line"></span>
<span class="line">              vollständige Totalwerte: ja</span>
<span class="line"></span>
<span class="line">Belegdatum</span>
<span class="line">    vereinbart    vereinnahmt        bezahlt gutgeschrieben     lfd. Saldo</span>
<span class="line">--------------------------------------------------------------------------------</span>
<span class="line">30.11.1996</span>
<span class="line">         29.50                                                       29.50</span>
<span class="line">31.01.1997</span>
<span class="line">     59,853.40     593,821.10    -870,500.95       7,404.86    -209,392.09</span>
<span class="line">28.02.1997</span>
<span class="line">     94,625.10     474,729.65    -547,511.00       1,579.40    -185,968.94</span>
<span class="line">31.03.1997</span>
<span class="line">     27,323.50         159.00        -194.00                   -158,680.44</span>
<span class="line">30.04.1997</span>
<span class="line">        327.50      18,307.85     -25,221.20       5,712.85    -159,553.44</span>
<span class="line">.</span>
<span class="line">.</span>
<span class="line">.</span>
<span class="line">30.04.1998</span>
<span class="line">        514.50                                        43.00    -154,922.29</span>
<span class="line">-------------- -------------- -------------- -------------- --------------</span>
<span class="line">                                                                           TOTAL</span>
<span class="line">    180,740.40   1,108,777.60  -1,467,689.45      23,249.16    -154,922.29</span>
<span class="line"></span>
<span class="line">        17                                                                 COUNT</span>
<span class="line">                      vollständige Totalwerte</span>
<span class="line">            vereinbart    vereinnahmt        bezahlt gutgeschrieben</span>
<span class="line">        -------------- -------------- -------------- --------------</span>
<span class="line">            180,740.40   1,108,777.60  -1,467,689.45      23,249.16</span>
<span class="line"></span>
<span class="line">Totalanzahl der Buchungen          351.00</span>
<span class="line">Debitoren Totaländerung       -154,922.29</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Lesebeispiel: Mit Monatsendedatum vom 28.2.97 wurden die entsprechenden kumulativen Beträge in den aggregierten Buchungen getätigt. Der laufende Saldo der Journalnummer beträgt Fr. 185'968.94.</p>
<p>Outputbeispiel ohne Totalwerte</p>
<p>Wie oben, aber ohne die Rekapitulation am Ende</p>
</div></template>


